'use strict';
var constants = require('../constants'),
    checkoutConfig = require('./checkout-config');
var svgSupported = document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');

function getWordmark(label, style, color, locale) {
    var wordmarkData;
    if (label === 'checkout' && checkoutConfig.getStyle(color, locale) === 'checkout') {
        if (color && color === 'blue') {
            style = 'checkout_reverse';
        } else {
            style = 'checkout';
        }
    }
    if (label === 'credit') {
        style = 'quaternary';
    }
    wordmarkData = constants.WORDMARK[style];
    // prefer SVG logo if supported
    if (svgSupported) {
        wordmarkData = constants.WORDMARK['vector_' + style];
    }
    return wordmarkData;
}

function getLogo() {
    var logoData = constants.LOGO;
    if (svgSupported) {
        logoData = constants.VECTOR_LOGO;
    }
    return logoData;
}
module.exports = {
    getWordmark: getWordmark,
    getLogo: getLogo
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/images.js
 ** module id = 9
 ** module chunks = 0
 **/